export function getItem(key) {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch {
    return null;
  }
}

export function setItem(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage unavailable
  }
}

export function removeItem(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    // Storage unavailable
  }
}

export function clearStorage() {
  try {
    localStorage.clear();
  } catch {
    // Storage unavailable
  }
}
